import { render, staticRenderFns } from "./CustomDesign.vue?vue&type=template&id=2f90ea72&scoped=true&"
import script from "./CustomDesign.vue?vue&type=script&lang=js&"
export * from "./CustomDesign.vue?vue&type=script&lang=js&"
import style0 from "./CustomDesign.vue?vue&type=style&index=0&id=2f90ea72&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f90ea72",
  null
  
)

export default component.exports